var React = require('react');

function IcWinnerComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-winner_1"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M4.93934 10.9207L2.65723 7.21668L5.82207 2.08447H12.178L15.3429 7.21668L13.0608 10.9207V16.5473L9.00005 15.1938L4.93934 16.5473V10.9207ZM5.91791 12.3488V15.1889L9.00005 14.1679L12.0822 15.1889V12.3488H5.91791ZM11.6255 3.06305H6.37462L3.80697 7.21663L6.37462 11.3702H11.6255L14.1931 7.21663L11.6255 3.06305ZM8.25052 8.42815L6.73219 6.90982L6.0331 7.60892L8.24913 9.80936L11.9665 6.07553L11.2698 5.39102L8.25052 8.42815Z","fill":"#006736"})));
}

IcWinnerComponent.defaultProps = {"width":"18","height":"19","viewBox":"0 0 18 19","fill":"none"};

module.exports = IcWinnerComponent;

IcWinnerComponent.default = IcWinnerComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/ResultTarifMobileV2/images/ic-winner.component.svg
// module id = 1646
// module chunks = 0